import { PermissionActionUnionType } from '../../types';

export const mapPermissionActionType = (
  rwd: number
): PermissionActionUnionType => {
  switch (rwd) {
    case 0:
      return 'READ';
    case 1:
      return 'WRITE';
    case 2:
      return 'DELETE';
    default:
      return 'READ';
  }
};
